/** Iter 639 — staff till split · shared axios client + tiny utils
 * (moved verbatim from pages/TillPage.jsx). Staff bearer token lives in
 * sessionStorage so the customer auth interceptors never interfere. */
import axios from "axios";
import { SHARED_ORIGIN } from "@/lib/api";

export const tillApi = axios.create({ baseURL: `${SHARED_ORIGIN || ""}/api` });
tillApi.interceptors.request.use((config) => {
  const t = sessionStorage.getItem("till_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  config.headers["X-App-Platform"] = "nz_classified";
  config.params = { ...(config.params || {}), platform: "nz_classified" };
  return config;
});

export function detail(err, fallback) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string" && d.trim()) return d;
  if (typeof d?.message === "string") return d.message;
  return fallback;
}

export function money(n) {
  const v = Number(n);
  return Number.isFinite(v) ? `$${v.toFixed(2)}` : null;
}

// Soft chimes (Web Audio, no asset). Safe to call repeatedly — the
// context is created lazily after the login click (a user gesture), so
// autoplay policy never blocks it. Two cues (Iter-462 follow-up):
//   "session" — two-tone ding, a customer just scanned in
//   "payment" — brighter rising triad, money landed
let chimeCtx = null;
const CHIME_NOTES = {
  session: [[880, 0], [1174.66, 0.16]],
  payment: [[1046.5, 0], [1318.51, 0.12], [1567.98, 0.24]],
};
export function playChime(kind = "session") {
  try {
    chimeCtx = chimeCtx || new (window.AudioContext || window.webkitAudioContext)();
    if (chimeCtx.state === "suspended") chimeCtx.resume();
    const t0 = chimeCtx.currentTime;
    (CHIME_NOTES[kind] || CHIME_NOTES.session).forEach(([freq, delay]) => {
      const osc = chimeCtx.createOscillator();
      const gain = chimeCtx.createGain();
      osc.type = "sine";
      osc.frequency.value = freq;
      gain.gain.setValueAtTime(0.0001, t0 + delay);
      gain.gain.exponentialRampToValueAtTime(0.12, t0 + delay + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, t0 + delay + 0.5);
      osc.connect(gain).connect(chimeCtx.destination);
      osc.start(t0 + delay);
      osc.stop(t0 + delay + 0.55);
    });
  } catch {
    // No audio available — silently skip.
  }
}
